import { useState } from 'react';
import '../../assets/css/case-home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

interface AwardRegion {
  name: string;
  awards: string[];
}

const AWARDS_DATA: AwardRegion[] = [
  {
    name: 'Tulsa Awards',
    awards: [
      '2023 Property Management Company of the Year \u2013 Case & Associates Properties, Inc. (Tulsa Apartment Association)',
      '2023 Community of the Year (built 2006 to 2019) \u2013 Park at Mission Hills (Tulsa Apartment Association)',
      '2023 Service Team of the Year (over 425 units) \u2013 Park at Mission Hills (Tulsa Apartment Association)',
      '2022 Community of the Year (built 2019 to present) \u2013 Redbud Ranch Apartments (Tulsa Apartment Association)',
      '2022 Community of the Year (built 1981\u20131993) \u2013 The Courtyards Apartments (Tulsa Apartment Association)',
      '2022 Division ORA\u2122 Power Ranking \u2013 Case & Associates is #7 among Top 10 Companies by online reputation in Division II (20,000-34,402 Units) (J Turner Research)',
      '2021 Community of the Year (built 1983-1991) \u2013 Sugarberry Apartments (Tulsa Apartment Association)',
      '2016 Community of the Year (built before 1980) \u2013 Eagle Point Apartments (Tulsa Apartment Association)',
      '2016 Broken Arrow Reader\u2019s Choice Award \u201cFavorite Apartment Complex\u201d \u2013 Park at Mission Hills Apts (Readers of the Broken Arrow Ledger)',
      '2015 Community of the Year (built 2010 to present) \u2013 Park at Mission Hills Apartments (Tulsa Apartment Association)',
      '2015 Broken Arrow Reader\u2019s Choice Award \u201cFavorite Apartment Complex\u201d \u2013 Park at Mission Hills Apts (Readers of the Broken Arrow Ledger)',
      '2015 Service Team of the Year (over 400 units) \u2013 Cascata Apartments (Tulsa Apartment Association)',
      '2015 Excellence Award \u2013 Cascata Apartments (National Corporate Housing)',
      '2013 Community of the Year (2007 to present) \u2013 Cascata Apartments (Tulsa Apartment Association)',
      '2010 Community of the Year (built 1981-1995) \u2013 One Eton Square Apartments (Tulsa Apartment Association)',
      '2010 Community of the Year (built 1996 to present) \u2013 Villas at Aspen Park Apartments (Tulsa Apartment Association)',
      '2008 Community of the Year (built prior to 1980) \u2013 Barcelona Apartments (Tulsa Apartment Association)',
      '2007 Community of the Year (built 1986-1999) \u2013 Villas at Bailey Ranch Apartments (Tulsa Apartment Association)',
      '2005 Best Resident Event \u2013 Barrington Apartments (Tulsa Apartment Association)',
      '2005 Community of the Year (built 1976-1989) \u2013 Barrington Apartments (Tulsa Apartment Association)',
    ],
  },
  {
    name: 'Oklahoma City Awards',
    awards: [
      '2023 Best of Moore & South OKC (Apartment Category) \u2013 Mission Point Apartments (Moore Monthly)',
      '2022 Community of the Year (6-20 years old) \u2013 Villas at Stonebridge Apartments (Apartment Association of Central Oklahoma)',
      '2022 Community of the Year (6-9 years old) \u2013 Mission Point Apartments (Apartment Association of Central Oklahoma)',
      '2022 Best of Moore & South OKC (Apartment Category) \u2013 Mission Point Apartments (Moore Monthly)',
      '2020 Reader\u2019s Choice Award \u2013 Mission Point Apartments (The Oklahoman)',
      '2018 Community of the Year (over 400 units) \u2013 Villas at Stonebridge Apartments (Apartment Association of Central Oklahoma)',
      '2018 Community of the Year (over 20 years old) \u2013 Hunters Ridge Apartments (Apartment Association of Central Oklahoma)',
      '2017 Community of the Year (over 20 years old) \u2013 Cimarron Pointe Apartments (Apartment Association of Central Oklahoma)',
      '2017 Property of the Year \u2013 Park at Westpointe Apartments (Apartment Association of Central Oklahoma)',
      '2015 Community of the Year (up to 5 years old) \u2013 Mission Point Apartments (Apartment Association of Central Oklahoma)',
      '2015 Community of the Year (6-20 years old) \u2013 Villas at Stonebridge Apartments (Apartment Association of Central Oklahoma)',
      '2015 Service Team of the Year \u2013 Woodscape Apartments (Apartment Association of Central Oklahoma)',
      '2013 Community of the Year (up to 5 years old) \u2013 Park at Tuscany Apartments (Apartment Association of Central Oklahoma)',
    ],
  },
  {
    name: 'Wichita Awards',
    awards: [
      '2023 Elite 1% ORA Power Ranking Property \u2013 Huntington Park Apartments (ORA J Turner Research)',
      '2014 Best Management Company \u2013 Case & Associates Properties, Inc. (Apartment Association of Greater Wichita)',
      '2014 Best Community \u2013 Newport Wichita Apartments (Apartment Association of Greater Wichita)',
    ],
  },
  {
    name: 'Amarillo Awards',
    awards: [
      '2023 Most Improved Property \u2013 Newport Apartments (Apartment Association of the Panhandle)',
      '2018 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2018 Best Kept Maintenance Shop \u2013 Winchester Apartments (Case & Associates Properties, Inc.)',
      '2017 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2017 News Channel 10 Viewers Choice Award \u201cBest Apartment Community\u201d \u2013 Winchester Apartments (News Channel 10)',
      '2016 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2015 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2014 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2013 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2012 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2011 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
      '2010 Best of Amarillo \u201cBest Apartment Complex\u201d \u2013 Colonies at Hillside Apartments (City of Amarillo)',
    ],
  },
  {
    name: 'Ridgeland Awards',
    awards: [
      '2023 Elite 1% ORA Power Ranking Property \u2013 The Pointe of Ridgeland Apartments (ORA J Turner Research)',
      '2017 Apartment Ratings TOP RATED \u2013 The Pointe of Ridgeland (Apartment Ratings)',
      '2016 Best of the Best Award \u2013 The Pointe of Ridgeland (Clarion Ledger)',
      '2015 Best of the Best Award \u2013 The Pointe of Ridgeland (Clarion Ledger)',
    ],
  },
  {
    name: 'Hewitt/Waco Awards',
    awards: [
      '2024 Elite 1% ORA Power Ranking Property \u2013 Icon at Hewitt Apartments (ORA J Turner Research)',
      '2023 Elite 1% ORA Power Ranking Property \u2013 Icon at Hewitt Apartments (ORA J Turner Research)',
      '2020 Power Rankings Elite 1% Award \u201cTop 1% for Reviews\u201d \u2013 Icon at Hewitt (ORA J Turner Research)',
      '2020 #1 Apartment for Property Management \u2013 Icon at Hewitt (Locals Love Us)',
      '2019 Power Rankings Elite 1% Award \u201cTop 1% for Reviews\u201d \u2013 Icon at Hewitt (ORA J Turner Research)',
      '2018 Power Rankings Elite 1% Award \u201cTop 1% for Reviews\u201d \u2013 Icon at Hewitt (ORA J Turner Research)',
    ],
  },
  {
    name: 'Lubbock Awards',
    awards: [
      '2021 Top 3 Apartments for Rent in Lubbock \u2013 Icon at Lubbock Apartments (ThreeBestRated)',
    ],
  },
];

export function AwardsAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const eyebrow = useContentToken('awardsaccordion.eyebrow');
  const sectionTitle = useContentToken('awardsaccordion.section_title');
  const intro = useContentToken('awardsaccordion.intro');

  return (
    <section className="case-awards-accordion">
      <hr className="case-awards-divider" aria-hidden="true" />
      <div className="case-container">
        <div className="case-awards-accordion-head">
          <EditableToken path="awardsaccordion.eyebrow" type="text" label="Eyebrow" defaultValue={contentSchema.tokens['awardsaccordion.eyebrow'].defaultValue} as="p" className="case-awards-accordion-eyebrow">
            {eyebrow}
          </EditableToken>
          <EditableToken path="awardsaccordion.section_title" type="text" label="Section Title" defaultValue={contentSchema.tokens['awardsaccordion.section_title'].defaultValue} as="h2" className="case-awards-accordion-title">
            {sectionTitle}
          </EditableToken>
          <EditableToken path="awardsaccordion.intro" type="text" label="Intro Text" defaultValue={contentSchema.tokens['awardsaccordion.intro'].defaultValue} as="p" className="case-awards-accordion-intro">
            {intro}
          </EditableToken>
        </div>
        <div className="case-awards-accordion-list">
          {AWARDS_DATA.map((region, index) => (
            <div className="case-awards-accordion-item" key={region.name}>
              <button
                type="button"
                className={`case-awards-accordion-btn${openIndex === index ? ' open' : ''}`}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
                aria-controls={`awards-region-${index}`}
              >
                <span>{region.name}</span>
                <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div
                id={`awards-region-${index}`}
                className={`case-awards-accordion-body${openIndex === index ? ' open' : ''}`}
                role="region"
              >
                <ul>
                  {region.awards.map((award, i) => (
                    <li key={i}>{award}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AwardsAccordion',
  displayName: 'Awards Accordion',
  tokens: {
    'awardsaccordion.eyebrow': {
      label: 'Eyebrow',
      type: 'text',
      defaultValue: 'By Location',
    },
    'awardsaccordion.section_title': {
      label: 'Section Title',
      type: 'text',
      defaultValue: 'Regional Awards',
    },
    'awardsaccordion.intro': {
      label: 'Intro Text',
      type: 'text',
      defaultValue: 'Local and regional honors earned community-by-community across the markets we serve.',
    },
  },
};

(AwardsAccordion as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AwardsAccordion;
